// local
import { TRENDS, STATE_URL, GEOGRAPHY_URL } from './constants.js';
// packages
import { json } from 'd3-fetch';
import {
  createFeed,
  createRaceFeed,
  createCandidateLookup,
  createSubunitLookup,
} from './stores.js';
import { topojsonToGeoJson } from './utils/geography.js';
import {
  renderSvelteComponent,
  findSvelteComponentContainer,
} from './utils/render.js';
import { derived } from 'svelte/store';

// components
import ResultsBar from './components/ResultsBar.svelte';
import ResultsMap from './components/ResultsMap.svelte';
import ResultsLegend from './components/ResultsLegend.svelte';
import { find } from './utils/array.js';

/**
 * @type {Map<string, import('../types.jsjs').Crosswalk>}
 */
const crosswalk = window.CROSSWALK.assets.img;

//components

async function main() {
  const stateFeed = await createFeed(STATE_URL);
  const senateRaceFeed = /**  @type {import('./types.d').RaceFeed}  */ (
    createRaceFeed(stateFeed, 'CA-S8619-2024-11-05')
  );
  const senRaceCandidateLookup = createCandidateLookup(senateRaceFeed);
  const senRaceSubunitLookup = createSubunitLookup(senateRaceFeed);

  // map data
  const topology = await json(GEOGRAPHY_URL);
  const [geography, roads, cities] = topojsonToGeoJson(topology, [
    'counties',
    'roads',
    'cities',
  ]);

  // get the containers
  let caSenateBar = findSvelteComponentContainer('#senate-results-bars');
  let caSenateMap = findSvelteComponentContainer('#results-map-senate');
  let caSenateMapLegend = findSvelteComponentContainer(
    '#results-legend-senate'
  );

  renderSvelteComponent(ResultsBar, /** @type {HTMLElement} */ caSenateBar, {
    feed: senateRaceFeed,
    crosswalk,
    candidate1: 'polid-89', // Schiff
    candidate2: 'polid-160951', // Garvey
    candidateLookup: senRaceCandidateLookup,
  });

  renderSvelteComponent(ResultsMap, /** @type {HTMLElement} */ caSenateMap, {
    geography,
    roads,
    cities,
    candidates: senRaceCandidateLookup,
    subunits: senRaceSubunitLookup,
    includeParty: true,
    feed: senateRaceFeed,
  });
  renderSvelteComponent(
    ResultsLegend,
    /** @type {HTMLElement} */ caSenateMapLegend,
    {
      race: senateRaceFeed,
    }
  );
}

main().catch(console.error);
